import { MutationTree } from 'vuex'

import { Mutations, PaymentDTO, PaymentPageData, PaymentState } from './types'

const mutations: MutationTree<PaymentState> = {
  [Mutations.SET_PAYMENT_PAGE_DATA]: (state, value) => {
    state.paymentPageData = value
  },

  [Mutations.SET_PAYMENT_FROM_BE]: (state, payment: PaymentDTO) => {
    const mappedPayment: PaymentPageData = {
      firstName: payment.name.first_name,
      lastName: payment.name.last_name,
      street: payment.address.street,
      houseNumber: payment.address.house_number,
      postcode: payment.address.postal_code,
      additionalAddressInformation: payment.address.additional_information,
      city: payment.address.city,
    }

    state.paymentPageData = mappedPayment
  },
}

export default mutations
